// extracted by mini-css-extract-plugin
export default {"container":"CancelledSubscriptions_container__RE8QG","title":"CancelledSubscriptions_title__WPBj3","tableContainer":"CancelledSubscriptions_tableContainer__kqGRF"};